export { default } from './DtrSummary.js';